export default "__VITE_ASSET__CUGpaqq7__"